var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailwindCssIcon9C4Bdccf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0.96875C14.6667 0.96875 11.3333 3.63542 10 8.96875C12 6.30208 14.3333 5.30208 17 5.96875C18.5215 6.34912 19.609 7.4529 20.8127 8.67475C22.7736 10.6651 25.043 12.9688 30 12.9688C35.3333 12.9688 38.6667 10.3021 40 4.96875C38 7.63542 35.6667 8.63542 33 7.96875C31.4785 7.58838 30.391 6.4846 29.1873 5.26275C27.2264 3.27238 24.957 0.96875 20 0.96875ZM10 12.9688C4.66667 12.9688 1.33333 15.6354 0 20.9688C2 18.3021 4.33333 17.3021 7 17.9688C8.52148 18.3491 9.60896 19.4529 10.8127 20.6747C12.7736 22.6651 15.043 24.9688 20 24.9688C25.3333 24.9688 28.6667 22.3021 30 16.9688C28 19.6354 25.6667 20.6354 23 19.9688C21.4785 19.5884 20.391 18.4846 19.1873 17.2628C17.2264 15.2724 14.957 12.9688 10 12.9688Z",
    fill: "url(#paint0_linear_423_735)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_423_735",
    x1: -284.444,
    y1: 1183.69,
    x2: 9516.7,
    y2: 4583.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2298BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ED7B5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24.0625,
    fill: "white",
    transform: "translate(0 0.96875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindCssIcon9C4Bdccf);
export default __webpack_public_path__ + "static/media/tailwind-css-icon.9c4bdccf.e640351c49f2c218157d6cbd9f68a797.svg";
export { ForwardRef as ReactComponent };